import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { EspecialidadI } from "interfaces/especialidad";
import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { createEspecialidadSchema } from "schemas/especialidades/createEspecialidadSchema";
import { postEspecialidad, putEspecialidad } from "services/especialidad";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: EspecialidadI;
  onSuccess?: (titulo: EspecialidadI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
}

const makeAniosOptionsSelect = (
  minAnio: number,
  maxAnio: number,
  interval: number = 1,
) => {
  const options: { label: any; value: any }[] = [];

  for (let i = minAnio; i <= maxAnio; i += interval) {
    options.push({ value: i, label: i });
  }

  return options;
};

export const EspecialidadABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const newEspecialidad = await postEspecialidad({ params });
      showSuccessToast("¡La especialidad fue creada con éxito!");
      if (onSuccess) onSuccess(newEspecialidad);
      onClose();
    } catch (err: any) {
      showErrorToast("La especialidad no pudo ser creada.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newEspecialidad = await putEspecialidad({ params });
      showSuccessToast("¡La especialidad fue editada con éxito!");
      if (onSuccess) onSuccess(newEspecialidad);
      onClose();
    } catch (err: any) {
      showErrorToast("La especialidad no pudo ser editada.");
      console.log(err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createEspecialidadSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Especialidad" : "Nueva Especialidad"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={12}>
                  <Input
                    id={"nombre"}
                    title="Nombre de la especialidad"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
